import { SubVertical, Vertical } from 'common/constants'

export interface Menu {
  id?: string
  title: string
  to: string
  className?: string
  flag?: Flag
  subMenus?: Menu[]
  nclick?: string
  vertical?: Vertical
  subVertical?: SubVertical
}

export interface Flag {
  type: FlagType
  className: string
}

export enum FlagType {
  NEW = 'NEW',
  BETA = 'BETA',
  SEPARATION = 'SEPARATION',
}

export enum TabType {
  CATEGORY = 'CATEGORY',
  DISPLAY = 'DISPLAY',
  COORDI = 'COORDI',
  INFO = 'INFO',
  NEWS = 'NEWS',
  NOT_FOUND = 'NOT_FOUND',
}

export enum BrandSearchTabType {
  MY = 'MY',
  CATEGORY = 'CATEGORY',
  INDEX = 'INDEX',
}

export interface TabItem {
  id: string
  title: string
  alias?: string
  clickCode?: any
}

export enum ShoppingBrandCategoryIndexType {
  BC001 = '여성패션',
  BC002 = '해외패션/화장품',
  BC003 = '럭셔리부띠끄',
  BC004 = '남성패션',
  BC005 = '영캐주얼',
  BC006 = '골프스포츠',
}
